import Popover from 'bootstrap/js/dist/popover';

var exampleEl = document.getElementsByClassName('accountTooltip');
for (var i = 0; i < exampleEl.length; i++) {
    new Popover(exampleEl[i], {
        container: 'body'
      });

}